//user
export const SET_USERNAME = 'SET_USERNAME'
export const SET_PASSWORD = 'SET_PASSWORD'
export const SET_TREEDTA = 'SET_TREEDTA'
export const SET_TOKEN = 'SET_TOKEN'
export const FIND_TO_TREE = "FIND_TO_TREE"



export const SET_TABDATA = 'SET_TABDATA'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js